import React, { useState, useEffect } from "react";
import QuickPayHeader from "./view/_header";
import { Hidden, Card, Grid, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { adminService } from "../../../services/index";
import MainContent from "./view/_main-content";
import EFooterSection from "../../e_home-page/e_footer-section/e_footer-section";
import { history } from "../../../helpers";
import { routePaths } from "../../config/route-paths";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  cardBackground: {
    background: theme.palette.eWhite.base,
  },
  marginFooter: {
    marginTop: "25px",
    height: "auto",
    padding: "2% 0% 0% 0%",
    borderRadius: "12px !important",
    background: theme.palette.eWhite.base,
  },
  cardContent: {
    height: "100%",
    margin: "0px 20px",
  },
  cardHeight:{
    height:"96vh"
  },
  '@global': {
    html: {
      height: "100%"
    },
    body: {
      height: "100%",
      backgroundColor: theme?.palette?.eFaint?.base,
      backgroundImage: "none !important"
    }
  },
  footerStyle:{
    bottom:0,
    alignContent:"center",
    width:"100%",
    [theme.breakpoints.up("md")]: {
      position:"fixed"
  } , [theme.breakpoints.down("md")]: {
    marginTop: "2%",
  },
  }
}));

export default function BalancePage() {
  const classes = useStyles();
  const [viewBalanceWidget, setViewBalanceWidget] = useState();
  let widgets = useSelector((state) => state?.parametersWidgets?.WidgetLookUp);
  let languageCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  const {t:content, ready: contentReady} = useTranslation(
    "content-E_AUTH_QUICK_PAY"
  );
 
  useEffect(() => {
    widgets &&
      widgets.map((item) => {
        if (item.widgetCode === "E_QUICKPAY") {
          let viewBalance = item?.children?.find((item) => item?.widgetCode == "E_QUICKPAY.VIEW_BALANCE")
          setViewBalanceWidget(viewBalance);
        }
      });
  }, [widgets]);
  const handleBeforeUnload=(e)=>{
    localStorage.setItem("viewBalance","true")
  }
  useEffect(()=>{ 
    if(localStorage.getItem("viewBalance") === 'true'){
      localStorage.removeItem("viewBalance")
      history.push(routePaths.QUICK_PAY)
    }
      window.addEventListener("beforeunload", handleBeforeUnload,{capture:true});
      return () => window.removeEventListener("beforeunload", handleBeforeUnload,{capture:true})
},[])

  return (
    <div>
      {
        viewBalanceWidget?.widgetDefaultValue && (
          <>
          <Card 
            className={classes.cardHeight}
            style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
          >
              <CardContent className={classes.cardBackground}>
                <QuickPayHeader data={contentReady ? content : ""} />
                <MainContent quickpayData={contentReady ? content : ""} />
              </CardContent>
              </Card>
              <Grid item xs={12} className={classes.footerStyle}>
                <EFooterSection />
              </Grid>
          </>
        )
      }
    </div>
  );
}
